export const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }: HTMLElement) => {
  return scrollHeight > clientHeight || scrollWidth > clientWidth;
};
